import { React, ReactRouter } from 'mcelroy-lib'
import { useUserContext } from 'mcelroy-components'
import { LogInPage } from './LogInPage'
import { UserProfilePage } from '../UserProfilePage'

/*
    Account page that either shows the log in form or the user's profile page
*/
export function AccountPage() {
    const [searchParams] = ReactRouter.useSearchParams()
    const { loading, user } = useUserContext()

    if (loading)
        return (null)
    else if (user.loggedIn)
        return (<UserProfilePage />)
    else
        return (<LogInPage />)
}